import {createFileRoute} from '@tanstack/react-router'
import React from "react";
import MarketPlaceView from "../../../marketplace/MarketPlaceView.tsx";

export const Route = createFileRoute('/_app/marketplace/$category')({
    component: RouteComponent,
})

function RouteComponent() {
    return <MarketPlaceView />
}
